import React from "react";
import axios from "axios";
import {axiosCommon} from "../../../util/axiosSetup.js";
import {BASE_URL} from "../../../util/Urls";
import Footer from "../../../components/Footer";
import {
    IconButton,
    Paper,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow, TextField,
    Toolbar,
    Typography
} from "@material-ui/core";
import Widget from "../../../components/Widget";
import Card from "../../../components/Card";
import DeleteIcon from "@material-ui/icons/Delete";
import DeleteDialog from "../../../components/DelteDialog";
import NewItemButton from "../../../components/NewItemButton";
import NavHeader from "../../../components/NavHeader";
import Autocomplete from "@material-ui/lab/Autocomplete";
import {
    getItem,
    removeSessionKeys,
    saveSessionKey
} from "../../../util/SessionStorageHandler";
import RowsPerPageOptions from "../../../util/RowsPerPageOptions";
import TablePagination from "@material-ui/core/TablePagination";
import Search from "../../../components/Search";

const ALL_SHOPS_OPTION = {id: null, name: "Összes üzlet"};

export default class KitchenDisplayListPage extends React.Component {
    constructor() {
        super();
        this.state = {
            allKitchenDisplays: [],
            kitchenDisplays: [],
            shopOptions: [ALL_SHOPS_OPTION],
            selectedShopOption: ALL_SHOPS_OPTION,
            deleteInProgress: null,
            error: null,
            preSavedShopOption: undefined,
            rowsPerPage: RowsPerPageOptions.defaultPageSize,
            page: 0,
            keyword: "",
        };
        this.selectedShopKey = 'kitchenDisplayListPageSelectedShop'
    }

    componentDidMount() {
        this.handleNavigation()

        axiosCommon.get(`${BASE_URL}/api/shops`)
            .then(response => {
                const shopOptions = [ALL_SHOPS_OPTION, ...response.data.items]
                const selectedShopOption = this.getSelectedShop(shopOptions);
                this.setState({shopOptions, selectedShopOption}, () => this.refreshData())
            })
    }

    componentWillUnmount() {
        const {selectedShopOption} = this.state
        if (selectedShopOption != null) saveSessionKey(this.selectedShopKey, selectedShopOption.id);
    }

    handleNavigation = () => {
        if (this.props.history.action === "POP") {
            const preSavedShopOption = getItem(this.selectedShopKey)
            this.setState({preSavedShopOption})
        } else {
            removeSessionKeys([this.selectedShopKey])
        }
    }

    getSelectedShop = (shopOptions) => {
        const shopId = this.state.preSavedShopOption

        if (shopId !== undefined && shopId !== null) {
            return shopOptions.find(shop => shop.id == shopId) || ALL_SHOPS_OPTION
        }

        return ALL_SHOPS_OPTION;
    }

    onChangeShopFilter = (event, value) => {
        this.setState({selectedShopOption: value, page: 0}, () => this.refreshData())
    };

    refreshData = () => {
        const shopsToLoad = this.state.shopOptions.filter(shop => shop.id !== null)

        axios.all(shopsToLoad.map(shop =>
            axiosCommon.get(`${BASE_URL}/api/kitchendisplay`, {params: {shopId: shop.id}})
                .then(response => response.data.map(kitchenDisplay => ({
                    ...kitchenDisplay,
                    shopId: shop.id,
                    shopName: shop.name,
                })))
        ))
            .then(results => {
                const allKitchenDisplays = results.flat()
                this.setState({allKitchenDisplays}, () => this.filterKitchenDisplays())
            })
            .catch(error => {
                this.setState({error})
            })
    };

    filterKitchenDisplays = () => {
        const {allKitchenDisplays, selectedShopOption, keyword} = this.state

        const kitchenDisplays = allKitchenDisplays
            .filter(kds => selectedShopOption.id === null || kds.shopId === selectedShopOption.id)
            .filter(kds => keyword === "" || kds.name.toLowerCase().includes(keyword.toLowerCase()))

        this.setState({kitchenDisplays})
    }

    setKeyword = (event) => this.setState({keyword: event.target.value, page: 0}, () => this.filterKitchenDisplays())

    initiateDeletion = (kitchenDisplay) => {
        this.setState({deleteInProgress: kitchenDisplay})
    };

    rejectDeletion = () => {
        this.setState({deleteInProgress: null})
    };

    confirmDeletion = () => {
        const {id} = this.state.deleteInProgress

        axiosCommon.delete(`${BASE_URL}/api/kitchendisplay/${id}`)
            .then(response => {
                const allKitchenDisplays = this.state.allKitchenDisplays.filter(item => item.id !== id)
                this.setState({deleteInProgress: null, allKitchenDisplays}, () => this.filterKitchenDisplays())
            })
            .catch(error => {
                this.setState({error, deleteInProgress: null});
            });
    };

    initiateEdit = (kitchenDisplay) => {
        this.props.history.push({
            pathname: "/customer/shops/editkitchendisplay",
            kitchenDisplayId: kitchenDisplay.id,
            shopId: kitchenDisplay.shopId,
        });
    };

    initiateCreate = () => {
        const shopId = this.state.selectedShopOption.id !== null
            ? this.state.selectedShopOption.id
            : this.state.shopOptions.find(shop => shop.id !== null)?.id

        this.props.history.push({
            pathname: "/customer/shops/editkitchendisplay",
            shopId,
        });
    };

    handleChangePage = (event, newPage) => this.setState({page: newPage})

    handleChangeRowsPerPage = (event) => this.setState({rowsPerPage: parseInt(event.target.value, 10), page: 0})

    renderDeleteDialog = () => {
        return <DeleteDialog
            title="Biztosan törlöd a konyhai kijelzőt?"
            open={this.state.deleteInProgress !== null}
            onConfirm={this.confirmDeletion}
            onClose={this.rejectDeletion}
            onReject={this.rejectDeletion}
        >
            A törlés nem visszavonható, az adatok véglegesen törlésre kerülnek!
        </DeleteDialog>;
    };

    renderList = () => {
        return <>
            <Widget>
                <Card title="Szűrés üzlet alapján">
                    <Autocomplete
                        fullWidth
                        noOptionsText="Nincs ilyen tétel"
                        options={this.state.shopOptions}
                        onChange={this.onChangeShopFilter}
                        disableClearable
                        getOptionLabel={(option) => option === "" ? "" : option.name}
                        getOptionSelected={(option, value) => option.id === value.id}
                        value={this.state.selectedShopOption || ""}
                        renderInput={(params) =>
                            <TextField {...params} label="Üzlet" variant="outlined"/>
                        }
                    />
                </Card>
                <div className="m-8"/>
                <Card title="Keresés a névben">
                    <Search
                        setKeyword={this.setKeyword}
                        refreshData={this.filterKitchenDisplays}
                        value={this.state.keyword}
                    />
                </Card>
            </Widget>

            <Paper>
                <Toolbar>
                    <Typography variant="h5" id="tableTitle" component="div">
                        Konyhai kijelzők
                    </Typography>
                </Toolbar>
                <TableContainer>
                    <Table>
                        <TableHead>
                            <TableRow>
                                <TableCell width="10%">ID</TableCell>
                                <TableCell width="20%">Név</TableCell>
                                <TableCell width="20%">Üzlet</TableCell>
                                <TableCell width="15%">IP cím</TableCell>
                                <TableCell align="center">Főkijelző</TableCell>
                                <TableCell align="right"/>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {this.state.kitchenDisplays
                                .slice(this.state.page * this.state.rowsPerPage, this.state.page * this.state.rowsPerPage + this.state.rowsPerPage)
                                .map((c) => {
                                    return <TableRow key={c.id} hover className="cursor-pointer" onDoubleClick={() => this.initiateEdit(c)}>
                                        <TableCell>{c.id}</TableCell>
                                        <TableCell>{c.name}</TableCell>
                                        <TableCell>{c.shopName}</TableCell>
                                        <TableCell>{c.ipAddress}</TableCell>
                                        <TableCell align="center">{c.isMainKitchenDisplay ? "Igen" : "Nem"}</TableCell>
                                        <TableCell padding="none" align="right">
                                            <IconButton aria-label="delete" onClick={() => this.initiateDeletion(c)}>
                                                <DeleteIcon/>
                                            </IconButton>
                                        </TableCell>
                                    </TableRow>
                                })
                            }
                        </TableBody>
                    </Table>
                    <TablePagination
                        labelRowsPerPage="Elemek az oldalon:"
                        rowsPerPageOptions={RowsPerPageOptions.items}
                        component="div"
                        count={this.state.kitchenDisplays.length}
                        rowsPerPage={this.state.rowsPerPage}
                        page={this.state.page}
                        onPageChange={this.handleChangePage}
                        onRowsPerPageChange={this.handleChangeRowsPerPage}
                    />
                </TableContainer>
            </Paper>

            {this.renderDeleteDialog()}
        </>
    }

    render() {
        return <>
            <section className="main-content">
                <section className="main-content-body">
                    <NavHeader changeSidebarToggled={this.props.changeSidebarToggled}/>
                    {this.renderList()}
                </section>

                <Footer/>
            </section>
            <NewItemButton
                title="Kijelző"
                onClick={this.initiateCreate}/>
        </>;
    }
}
